import { Action, ActionFunctionAny } from 'redux-actions';
import { put, takeEvery } from 'redux-saga/effects';

import { userModalActions } from 'components/usersModal';

import { presenceActions } from '../../presence/actions/presenceActions';
import { transferToAgentActions } from '../../shared/transferToAgentModal/actions/transferToAgentModal';
import { transferToNumberActions } from '../../shared/transferToNumberModal/actions/transferToNumberModal';
import { transferToQueueActions } from '../../shared/transferToQueueModal/actions/transferToQueueModal';
import { actions as conversationActions } from '../actions/conversation';
import { actions as conversationsActions } from '../actions/conversations';

const { transferToQueueModalRequestSucceeded } = transferToQueueActions;

const {
  transferToNumberAssistedResolveSucceeded,
  transferToNumberBlindRequestSucceeded,
} = transferToNumberActions;

const { transferToAgentAssistedResolveSucceeded } = transferToAgentActions;

const {
  conversationsAdd,
  conversationsUpdateUser,
  conversationsUnassignSelf,
  conversationsSaveTempFormValues,
  conversationsSaveTempWrapup,
  conversationsSaveTempCurrentTab,
  conversationsCloseConversation,
  conversationsConversationToPending,
  conversationsConversationCancelPending,
  conversationsConversationOfferAccepted,
  conversationsConversationClaimed,
  conversationsConversationTransfered,
  conversationsConversationAssistedTransferAccepted,
} = conversationsActions;

const {
  conversationGetSucceeded,
  conversationSaveTempWrapup,
  conversationSaveTempCurrentTab,
  conversationSaveTempFormValues,
  conversationCloseSucceeded,
  conversationToPendingSucceeded,
  conversationCancelPendingSucceeded,
  conversationRespondeToOfferAcceptedSucceeded,
  conversationClaimSucceeded,
} = conversationActions;

const updateConversationsFromPresenceGet = takeEvery(
  presenceActions.presenceGetSucceeded,
  function* ({ payload }) {
    // Do not update if isOwnAgent flag is provided and false, to maintain compatibility.
    if (payload.user_id.isOwnAgent === false) {
      return;
    }

    const presenceUser = payload.data.presence;
    const loadDescriptions = presenceUser.presence_status.load_descriptions;

    yield put(conversationsActions.conversationsUpdate(loadDescriptions));
  },
);

// `presenceWsSetOwnStatus` is dispatched by the websocket saga only when the
// `presence:agent_status_changed` event is for the current user, so no
// ownership check is needed here. Without this listener, a newly auto-assigned
// conversation only reaches the sidebar via an HTTP presence refresh (initial
// load, page refresh, or websocket reconnect).
const updateConversationsFromPresenceWs = takeEvery(
  presenceActions.presenceWsSetOwnStatus,
  function* ({ payload }) {
    const loadDescriptions = payload.params.presence.load_descriptions ?? [];
    yield put(conversationsActions.conversationsUpdate(loadDescriptions));
  },
);

const actions: [
  string | ActionFunctionAny<Action<unknown>>,
  ActionFunctionAny<Action<unknown>>,
][] = [
  [conversationGetSucceeded, conversationsAdd],
  [userModalActions.user.update.fulfilled.type, conversationsUpdateUser],
  [transferToQueueModalRequestSucceeded, conversationsUnassignSelf],
  [conversationSaveTempFormValues, conversationsSaveTempFormValues],
  [conversationSaveTempWrapup, conversationsSaveTempWrapup],
  [conversationSaveTempCurrentTab, conversationsSaveTempCurrentTab],
  [conversationCloseSucceeded, conversationsCloseConversation],
  [conversationToPendingSucceeded, conversationsConversationToPending],
  [conversationCancelPendingSucceeded, conversationsConversationCancelPending],
  [
    conversationRespondeToOfferAcceptedSucceeded,
    conversationsConversationOfferAccepted,
  ],
  [conversationClaimSucceeded, conversationsConversationClaimed],
  [transferToNumberBlindRequestSucceeded, conversationsConversationTransfered],
  [
    transferToNumberAssistedResolveSucceeded,
    conversationsConversationAssistedTransferAccepted,
  ],
  [
    transferToAgentAssistedResolveSucceeded,
    conversationsConversationAssistedTransferAccepted,
  ],
];
const mapActions = actions.map(([fromAction, toAction]) =>
  takeEvery(fromAction.toString(), function* (action: Action<unknown>) {
    yield put(toAction(action.payload));
  }),
);

export const conversations = [
  updateConversationsFromPresenceGet,
  updateConversationsFromPresenceWs,
  ...mapActions,
];
